import { IKeywordsItem } from './interface'

class Format {
    public static keywordsToSearchItem(keywords: string[], currentKeyword: string): IKeywordsItem[] {
        const result: IKeywordsItem[] = []
        Array.isArray(keywords) && keywords.forEach(item => {
            result.push({
                name: item,
                isSelected: item === currentKeyword ? true : false
            })
        })
        return result
    }
}

export {
    Format
}


// WEBPACK FOOTER //
// ./src/components/activity_detail/search/helper.ts